import { THEME_NAMES } from "./config";
import { assetPackIds } from "nemuru-components";

export const astaraTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.astara,
  logoUrl:
    "https://nemuru-assets.s3.eu-west-1.amazonaws.com/astara/logo/astara-logo-inverted.png",
  palette: {
    primary: {
      main: "#fab42d",
      contrastText: "#1E1932",
    },
    secondary: {
      main: "#524589",
      contrastText: "#fff",
    },
    warning: {
      main: "#ffca28",
      contrastText: "#ffffff",
      light: "rgba(255, 202, 40, 0.15)",
    },
    info: {
      main: "#2377D1",
      contrastText: "#ffffff",
      light: "#E9F1FA",
    },
    success: {
      main: "#069C64",
      contrastText: "#E6F5EF",
      light: "rgba(73,217,106,0.15)",
    },
    error: {
      main: "#d01002",
      contrastText: "#ffffff",
      light: "rgba(208,16,2,0.15)",
    },
    text: {
      title: "#1E1932",
      primary: "#1E1932",
      secondary: "#676570",
    },
    // additional colors
    dark: {
      main: "#524589",
      accent: "#524589",
      contrastText: "#ffffff",
      imageBackgroundOpacity: 0.8,
    },
    status: {
      active: "#4dd970",
      approved: "#43b46f",
      analysing: "#36a3f7",
      sent: "#08404d",
      cancelled: "#d8d8d8",
      denied: "#ef5957",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.FILLED,
  background: "#E9E9E9",
  typography: {
    fontFamily: "Montserrat, Helvetica, sans-serif",
  },
  customBorderRadius: {
    button: 5,
    paper: 15,
    chip: 6,
  },
};
